import React from 'react';
import { Button, IconButton } from './Button';
import { IconChevronLeft, IconClose } from './icons';

/**
 * Record panel chrome for master/detail views and full-page records:
 * 48px header (back button below the master/detail breakpoint, ‹ › and More
 * in `actions`, Close otherwise) + a scrolling body supplied by the caller.
 */
export const Panel: React.FC<{
  title: React.ReactNode;
  actions?: React.ReactNode;
  onClose: () => void;
  /** Show "‹ {backLabel}" instead of a close button (narrow layouts, full-page records). */
  showBack?: boolean;
  backLabel?: string;
  ariaLabel: string;
  children: React.ReactNode;
}> = ({
  title,
  actions,
  onClose,
  showBack,
  backLabel = 'Back',
  ariaLabel,
  children,
}) => (
  <section
    aria-label={ariaLabel}
    className="flex h-full min-w-0 flex-col bg-v2-surface"
  >
    <header className="flex h-12 shrink-0 items-center gap-2 border-b border-v2-line px-4">
      {showBack ? (
        <Button
          size="sm"
          variant="ghost"
          leading={<IconChevronLeft size={14} />}
          onClick={onClose}
          className="-ml-2"
        >
          {backLabel}
        </Button>
      ) : null}
      <div className="min-w-0 flex-1 truncate">{title}</div>
      {actions}
      {!showBack && (
        <IconButton size="sm" label="Close" onClick={onClose}>
          <IconClose />
        </IconButton>
      )}
    </header>
    {children}
  </section>
);
